import { css } from '@emotion/react';

import { Flex } from '@toolbox/components';
import { makeStyles } from '@toolbox/style';
import { icons } from '@toolbox/components/Icon/icons';
import { Icon } from '@toolbox/components/Icon';

import type { ReactElement } from 'react';

const useStyles = makeStyles(({ theme }) => ({
  root: css`
    display: flex;
    justify-content: start;
    column-gap: ${theme.spacing(2)};

    ${theme.media.up('md')} {
      margin: 0 ${theme.spacing(8)};
    }
  `,
  rootBig: css`
    display: flex;
    justify-content: start;
    column-gap: ${theme.spacing(2)};

    ${theme.media.up('md')} {
      margin: 0;
    }
  `,
  icon: css`
    flex-shrink: 0;
    font-size: 12px;
    ${theme.media.up('md')} {
      font-size: 14px;
    }
  `,
  iconBig: css`
    flex-shrink: 0;
    font-size: 35px;
    ${theme.media.up('sm')} {
      font-size: 45px;
    }
    ${theme.media.up('md')} {
      font-size: 55px;
    }
  `,
  label: css`
    margin: 0;
    font-size: 12px;
    text-align: start;
    ${theme.media.up('md')} {
      font-size: 14px;
    }
  `,
}));

export type USPItemProps = {
  label?: string;
  icon?: keyof typeof icons | '' | ReactElement;
  iconBig?: boolean;
};

export const USPItem = ({ label, iconBig }: USPItemProps): JSX.Element => {
  const classes = useStyles();
  const rootClass = iconBig ? classes.rootBig : classes.root;

  return (
    <Flex css={rootClass as any}>
      <p css={classes.label as any}>{label}</p>
    </Flex>
  );
};

export const USPItemOld = ({ label, icon, iconBig }: USPItemProps): JSX.Element => {
  const doesIconExist = typeof icon === 'string' && icon in icons;
  const classes = useStyles();

  const iconClass = iconBig ? classes.iconBig : classes.icon;
  const rootClass = iconBig ? classes.rootBig : classes.root;

  return (
    <Flex alignItems={'center'} css={rootClass as any} justifyContent="center">
      {icon && (doesIconExist ? <Icon css={iconClass as any} type={icon} /> : icon)}
      <p css={classes.label as any}>{label}</p>
    </Flex>
  );
};
